import { useGetAccessoriesQuery } from '@/api/accessories'
import React from 'react'
import SearchResult from '../SearchResult/SearchResult'

type Props = {}

const AccessorySearch = (props: Props) => {
  const { data, isFetching } = useGetAccessoriesQuery()

  const settings = {
    showBrand: true,
    showModel: false,
    showTyreInfo: false,
    test: true
  }

  return (
    <div>
      <SearchResult
        isFetching={isFetching}
        items={data}
        settings={settings}
        listId={'search_accessories'}
        listName={'Search Accessories'}
      />
    </div>
  )
}

export default AccessorySearch